import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LocalizationProviderWrapper } from '@app/shared/providers/LocalizationProviderWrapper';
import { hfMuiTheme } from '@app/shared/theme/hfMuiTheme';
import ErrorDialogManager from '@root/app/shared/new-components/hf-error-dialog/ErrorDialogManager';
import { router } from '@root/app/routing/router';

const App: React.FC = () => (
    <ThemeProvider theme={hfMuiTheme}>
        <CssBaseline />
        <LocalizationProviderWrapper>
            <RouterProvider router={router} />
            <ToastContainer />
            <ErrorDialogManager />
        </LocalizationProviderWrapper>
    </ThemeProvider>
);

export default App;
